import { UserRound, Truck, MapPin, Check, X, AlertTriangle, Clock, Wrench, Ban } from "lucide-react";

// Mirrors backend scheduler.SHIFT_STATUSES
export const SHIFT_STATUS_META = {
  upcoming: { label: "Up Coming", colour: "slate", Icon: UserRound },
  new: { label: "New", colour: "blue", Icon: UserRound },
  en_route: { label: "En Route", colour: "slate", Icon: Truck },
  in_progress: { label: "In Progress", colour: "purple", Icon: MapPin },
  completed: { label: "Completed", colour: "emerald", Icon: Check },
  abandoned: { label: "Abandoned", colour: "rose", Icon: X },
  suspended: { label: "Suspended", colour: "amber", Icon: AlertTriangle },
  late: { label: "Late to Shift", colour: "amber", Icon: Clock },
};

export const ASSET_STATE_META = {
  maintenance: { label: "Maintenance", colour: "amber", Icon: Wrench },
  unavailable: { label: "Unavailable", colour: "rose", Icon: Ban },
};

export const SHIFT_STATUS_ORDER = ["upcoming", "new", "en_route", "in_progress", "completed", "abandoned", "suspended", "late"];

export function statusMeta(key) {
  return SHIFT_STATUS_META[key] || SHIFT_STATUS_META.upcoming;
}
